// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e9d92d13","488":"45d30aaa","977":"c594d75e"}[chunkId] + ".chunk.js";
};